module.exports = __webpack_public_path__ + "img/kania.a0240518.png";